const helper = {
	methods: {
		convertDate(dateString) {
			// Create a new Date object from the input string
			const date = new Date(dateString);

			// Get the day, month, and year from the Date object
			const day = date.getDate();
			const month = date.toLocaleString("default", { month: "short" });
			const year = date.getFullYear();

			// Format the date as "DD Mon, YYYY"
			const formattedDate = `${day} ${month}, ${year}`;

			return formattedDate;
		},
		formatDate(createdDate) {
			const date = new Date(createdDate);
			const day = String(date.getDate()).padStart(2, "0");
			const month = String(date.getMonth() + 1).padStart(2, "0");
			const year = date.getFullYear();

			return `${day}-${month}-${year}`;
		},
		//converting into time string
		convertTime(timeString) {
			if (!timeString) return "0 min";
			const [hours = 0, minutes = 0] = timeString.split(":").map(Number);
			let readableTime = [];
			if (hours > 0) {
				readableTime.push(`${hours} hours`);
			}
			if (minutes > 0) {
				readableTime.push(`${minutes} minutes`);
			}
			// If both hours and minutes are 0
			return readableTime.length ? readableTime.join(", ") : "0 min";
		},
		timeAgo(dateString) {
			const now = new Date();
			const createdDate = new Date(dateString);
			const createdDateIST = new Date(
				createdDate.getTime() + (5 * 60 + 30) * 60 * 1000
			);
			const secondsAgo = Math.floor((now - createdDateIST) / 1000);

			if (secondsAgo < 60) {
				return "Just now";
			}

			const minutesAgo = Math.floor(secondsAgo / 60);
			if (minutesAgo < 60) {
				return `${minutesAgo} minute${minutesAgo > 1 ? "s" : ""} ago`;
			}

			const hoursAgo = Math.floor(minutesAgo / 60);
			if (hoursAgo < 24) {
				return `${hoursAgo} hour${hoursAgo > 1 ? "s" : ""} ago`;
			}

			const daysAgo = Math.floor(hoursAgo / 24);
			if (daysAgo < 7) {
				return `${daysAgo} day${daysAgo > 1 ? "s" : ""} ago`;
			}

			const weeksAgo = Math.floor(daysAgo / 7);
			if (weeksAgo < 4) {
				return `${weeksAgo} week${weeksAgo > 1 ? "s" : ""} ago`;
			}

			if (daysAgo > 30) {
				const options = { month: "short", day: "numeric", year: "numeric" };
				return `On ${createdDateIST.toLocaleDateString("en-US", options)}`;
			}

			return createdDate.toLocaleDateString(); // Fallback to date format
		},
		getDuration(duration) {
			if (!duration) return "0 min";
			if (duration[0] !== "0") {
				return duration[0] + duration[1] + " hr";
			} else if (duration[1] !== "0") {
				return duration[1] + " hr";
			} else if (duration[3] !== "0") {
				return duration[3] + duration[4] + " min";
			} else if (duration[4] !== "0") {
				return duration[4] + " min";
			} else {
				return duration[6] + duration[7] + " secs";
			}
		},
	},
};

export default helper;
